import { graphql, readInlineData } from "react-relay";

import { checkIsLongReadArticle } from "~/components/article/article-render/long-read-article/helpers";
import { checkIsMorningStudioArticle } from "~/components/article/article-render/morning-studio-article/helpers";
import { checkIsPhotoEssayArticle } from "~/components/article/article-render/photo-essay-article/helpers";
import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { checkIsStyleArticle } from "~/components/article/article-render/style-article/helper";
import { checkIsPostiesPage } from "~/components/pages/posties-pages/helpers";
import { checkIsStyleSectionContent } from "~/components/section/helpers";
import { appBarConfiguration as sectionStyleAppBarConfiguration } from "~/components/section/section-style/const";
import type { helpersAppBarAdStatusBase$key } from "~/queries/__generated__/helpersAppBarAdStatusBase.graphql";
import type { helpersAppBarVariantArticle$key } from "~/queries/__generated__/helpersAppBarVariantArticle.graphql";
export type AppBarVariant =
  | "genericLight"
  | "genericDark"
  | "posties"
  | "postiesBrochure"
  | "magazines-style"
  | "scrollOver"
  | "home";

export const AppBarColorScheme: Record<AppBarVariant, "light" | "dark"> = {
  genericDark: "dark",
  genericLight: "light",
  home: "light",
  "magazines-style": "light",
  posties: "light",
  postiesBrochure: "light",
  scrollOver: "dark",
};

export const getAppBarVariant = (reference: helpersAppBarVariantArticle$key) => {
  const content = readInlineData(
    graphql`
      fragment helpersAppBarVariantArticle on Base @inline {
        ...helpersCheckIsPostiesArticle
        ...helpersCheckIsLongReadArticle
        ...helpersCheckIsMorningStudioArticle
        ...helpersCheckIsPhotoEssayArticle
        ...helpersCheckIsStyleArticle
        ...helpersStyleSectionContent
        ...helpersCheckIsPostiesPage
      }
    `,
    reference,
  );

  if (checkIsStyleArticle(content) || checkIsStyleSectionContent(content))
    return sectionStyleAppBarConfiguration.appBarVariant;
  if (checkIsPhotoEssayArticle(content) || checkIsLongReadArticle(content)) return "scrollOver";
  if (checkIsMorningStudioArticle(content)) return "genericDark";
  if (checkIsPostiesArticle(content) || checkIsPostiesPage(content)) return "posties";

  return "genericLight";
};

export type AppBarAdStatus = "Enabled" | undefined;
export const getAppBarAdStatusByContent = (reference: helpersAppBarAdStatusBase$key) => {
  const content = readInlineData(
    graphql`
      fragment helpersAppBarAdStatusBase on Base @inline {
        ... on Section {
          __typename
          ...helpersStyleSectionContent
        }
      }
    `,
    reference,
  );

  return content.__typename === "Section" && checkIsStyleSectionContent(content)
    ? sectionStyleAppBarConfiguration.appBarAdStatus
    : undefined;
};
